import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import Header from '../Comoponents/Header';
import Hero from '../Comoponents/Hero';
import About from '../Comoponents/About';
import AppDes from '../Comoponents/AppDes';
import Chooseus from '../Comoponents/Chooseus';
import Services from '../Comoponents/Services';
import Safaty from '../Comoponents/Safaty';
import CTA from '../Comoponents/CTA';
import Footer from '../Comoponents/Footer';

function Home() {

  const location = useLocation();

  useEffect(() => {
    let sectionId = "";

    switch (location.pathname) {
      case "/about-us":
        sectionId = "about";
        break;
      case "/services":
        sectionId = "services";
        break;
      case "/choose-us":
        sectionId = "choose";
        break;
      case "/contact-us":
        sectionId = "contact";
        break;
      default:
          window.scrollTo({ top: 0, behavior: "smooth" });
      return;
    }

    if (sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <div>
      <Header/>
      <Hero/>
      <About/>
      <AppDes/>
      <Chooseus/>
      <Services/>
      <Safaty/>
      <CTA/>
      <Footer/>
    </div>
  );
}

export default Home;
